const CheckMark = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='10'
    viewBox='0 0 14 10'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.707.293a1 1 0 0 1 0 1.414l-8.007 8a1.001 1.001 0 0 1-1.415 0l-4.004-4a1 1 0 0 1 1.415-1.414l3.296 3.293 7.3-7.293a1.001 1.001 0 0 1 1.415 0Z'
      fill='currentColor'
    />
  </svg>
);

export default CheckMark;
